<!-- Tapping the dimmed area closes it; the card stops the click so tapping it does not. -->
<div
  class="sent"
  [class.sent--reduced]="reduced"
  role="dialog"
  aria-modal="true"
  aria-labelledby="task-sent-title"
  (click)="close()"
>
  <div class="card" (click)="$event.stopPropagation()">
    <button type="button" class="card__close" aria-label="Cerrar" (click)="close()">
      <mat-icon class="mdi mdi-close"></mat-icon>
    </button>

    <div class="card__body">
      <!-- the sheet fills its lines, folds away and turns into the paper plane (see the SCSS timeline) -->
      <svg class="art" viewBox="0 0 200 180" width="200" height="180" aria-hidden="true">
        <g class="art__fold">
          <g class="art__doc">
            <rect class="art__sheet-back" x="54" y="26" width="112" height="140" rx="12"></rect>
            <rect class="art__sheet" x="44" y="18" width="112" height="140" rx="12"></rect>
            <rect class="art__sheet-tint" x="44" y="18" width="112" height="140" rx="12"></rect>
            <rect class="art__heading" x="64" y="38" width="40" height="8" rx="4"></rect>
            <g *ngFor="let line of lines">
              <rect class="art__track" x="64" [attr.y]="line.y" [attr.width]="line.w" height="6" rx="3"></rect>
              <rect class="art__ink" x="64" [attr.y]="line.y" [attr.width]="line.w" height="6" rx="3"
                [style.animation-delay]="line.delay"></rect>
            </g>
          </g>
        </g>

        <rect *ngFor="let streak of streaks" class="art__streak" [class.art__streak--strong]="streak.strong"
          [attr.x]="streak.x" [attr.y]="streak.y" [attr.width]="streak.w" height="5" rx="2.5"
          [style.animation-delay]="streak.delay"></rect>

        <g transform="translate(38 28) scale(5)">
          <g class="art__plane">
            <path class="art__plane-body" d="M2,21L23,12L2,3V10L17,12L2,14V21Z"></path>
            <!-- the upper wing a shade lighter: the plane's fold, without a gradient id to resolve -->
            <path class="art__plane-wing" d="M2,3L23,12L17,12L2,10Z"></path>
          </g>
        </g>
      </svg>

      <h2 id="task-sent-title" class="card__title fade fade--1">¡Tarea enviada!</h2>
      <p *ngIf="name" class="card__name fade fade--2">{{ name }}</p>
      <span class="card__chip fade fade--3">Documento enviado · En revisión</span>
      <p class="card__message fade fade--4">
        Recibimos tu documento. Te avisaremos cuando la revisión esté lista; mientras tanto, puedes continuar
        con tu ruta.
      </p>
      <button type="button" class="card__action fade fade--5" (click)="close()">Continuar con la ruta</button>
    </div>
  </div>
</div>
